import { IAdminRole } from 'APIPackage/AdminModule/interfaces/IAdminRole';

import { IRolesSelectOption } from '../interfaces/IRoleSelectOption';

export const createRolesSelectOption = (role: IAdminRole): IRolesSelectOption => ({
  ...role,
  id: role.id,
  value: role.code,
  label: role.name,
});
